/* src/app/shared/components/not-registered/not-registered.component.scss */
.route-component {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
}
.search-component {
  text-align: center;
  padding: 2rem;
  max-width: 500px;
}
.search-component h4 {
  color: #dc3545;
  margin-bottom: 1rem;
}
.search-component p {
  margin-bottom: 0.5rem;
  color: #666;
}
.search-component .btn {
  margin-top: 1rem;
}
/*# sourceMappingURL=not-registered.component-UURR76C6.css.map */
